import { FC, ReactNode } from 'react';

import { Table } from '@ravago/shared/radiance/components/table/components/Table/Table';
import { TableBody } from '@ravago/shared/radiance/components/table/components/TableBody/TableBody';
import { TableCell } from '@ravago/shared/radiance/components/table/components/TableCell/TableCell';
import { TableHeader } from '@ravago/shared/radiance/components/table/components/TableHeader/TableHeader';
import { TableRow } from '@ravago/shared/radiance/components/table/components/TableRow/TableRow';
import { TableSubheader } from '@ravago/shared/radiance/components/table/components/TableSubheader/TableSubheader';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';

export interface Properties {
   [key: string]: { label: string; value?: ReactNode; dataCy?: string };
}

interface Props {
   properties: Properties;
   primaryColour?: boolean;
   rowDividers?: boolean;
   greyHeader?: boolean;
   stroked?: boolean;
   rounded?: boolean;
}

export const ItemInformationTable: FC<Props> = ({ properties, rounded, primaryColour, rowDividers, greyHeader, stroked }) => (
   <Table rounded={rounded} rowDividers={rowDividers} stroked={stroked ? 'horizontal' : 'none'} tableLayout="fixed">
      <TableBody>
         {Object.keys(properties).map((key) => (
            <TableRow key={properties[key].label}>
               {greyHeader ? (
                  <TableSubheader verticalAlign="top">
                     <Typography color={primaryColour ? 'primary' : undefined} variant="body-highlight" component="b">
                        {properties[key].label}
                     </Typography>
                  </TableSubheader>
               ) : (
                  <TableHeader>
                     <Typography color={primaryColour ? 'primary' : undefined} variant="body-highlight" component="b">
                        {properties[key].label}
                     </Typography>
                  </TableHeader>
               )}
               <TableCell>
                  <span data-test-selector={properties[key].dataCy}>{properties[key].value ?? '-'}</span>
               </TableCell>
            </TableRow>
         ))}
      </TableBody>
   </Table>
);
